import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { DpOrderEntry } from '@app/core/types/view/dp-order-entry.interface';
import { CART_ADDITIONAL_FIELDS_FEATURE } from '@app-modules/cart/store/cart-additional-fields-feature.constant';

export const CartAdditionalFieldsActions = createActionGroup({
  source: CART_ADDITIONAL_FIELDS_FEATURE,
  events: {
    initializeFields: props<{
      payload: { additionalFields: string[]; entries: DpOrderEntry[]; completeDelivery?: boolean };
    }>(),
    toggleFieldsVisibility: props<{ expanded: boolean }>(),
    toggleOneShippingDelivery: props<{ isOneShippingDelivery: boolean }>(),
    updateEntryValue: props<{ payload: { entryNumber: number; label: string; value: string | number } }>(),
    removeEntryValues: props<{ entryNumber: number }>(),
    clearEntriesValues: emptyProps(),
    selectEntry: props<{ entryNumber: number }>(),
    unselectEntry: props<{ entryNumber: number }>(),
    selectAllEntries: props<{ selectedEntries: number[] }>(),
    unSelectAllEntries: emptyProps(),
    resetFields: emptyProps()
  }
});
